import {
  NOTE_PREVIEW_LEADING_NOTE_MARKER,
  NOTE_PREVIEW_NUMBER_PREFIX_PATTERN,
  NOTE_PREVIEW_NUMBERED_ENTRY_PATTERN,
} from "./note-preview-constant";
import { isFreeTextTitle, splitIntoBullets } from "./note-preview-line-utils";
import {
  NotePreviewHierarchyGroup,
  NotePreviewLine,
} from "./note-preview-types";

const isSubSection = (line: NotePreviewLine) =>
  !!line.title &&
  !line.isNested &&
  NOTE_PREVIEW_NUMBERED_ENTRY_PATTERN.test(line.title);

/**
 * Builds the Social History hierarchy: each "n. Title" line opens a sub-section
 * whose text is its ticked options; the nested lines that follow, until the next
 * numbered line, are its notes (free-text titles) or labelled details.
 */
export const buildHierarchyGroups = (
  lines: NotePreviewLine[]
): NotePreviewHierarchyGroup[] =>
  lines.reduce<NotePreviewHierarchyGroup[]>((groups, line) => {
    if (isSubSection(line)) {
      groups.push({
        title: (line.title ?? "").replace(
          NOTE_PREVIEW_NUMBER_PREFIX_PATTERN,
          ""
        ),
        selections: splitIntoBullets(line.text),
        details: [],
        notes: [],
      });
      return groups;
    }
    const current = groups[groups.length - 1];
    if (!current) return groups;
    if (!line.title || isFreeTextTitle(line.title))
      current.notes.push(
        line.text.replace(NOTE_PREVIEW_LEADING_NOTE_MARKER, "")
      );
    else current.details.push({ label: line.title, value: line.text });
    return groups;
  }, []);
